import React from "react";
import { View, Text, Image } from "react-native";

export type Mood = {
  key:
    | "confident"
    | "happy"
    | "okay"
    | "neutral"
    | "confused"
    | "sad"
    | "frustrated"
    | "tired"
    | "overwhelmed"
    | "could_not_concentrate";
  label: string;
  description: string;
  emojiImageKey: string;
};

export const moods: Mood[] = [
  {
    key: "confident",
    label: "Confident",
    description: "Proud of what I achieved.",
    emojiImageKey: "confident",
  },
  {
    key: "happy",
    label: "Happy",
    description: "Felt good, everything made sense.",
    emojiImageKey: "happy",
  },
  {
    key: "okay",
    label: "Okay",
    description: "Some parts were good, some tricky.",
    emojiImageKey: "okay",
  },
  {
    key: "neutral",
    label: "Neutral",
    description: "Not much to say.",
    emojiImageKey: "neutral",
  },
  {
    key: "confused",
    label: "Confused",
    description: "Didn’t understand some of the material.",
    emojiImageKey: "confused",
  },
  {
    key: "sad",
    label: "Sad",
    description: "Felt upset or low.",
    emojiImageKey: "sad",
  },
  {
    key: "frustrated",
    label: "Frustrated",
    description: "Felt uneasy.",
    emojiImageKey: "frustrated",
  },
  {
    key: "tired",
    label: "Tired",
    description: "Felt low energy/drained.",
    emojiImageKey: "tired",
  },
  {
    key: "overwhelmed",
    label: "Overwhelmed",
    description: "Felt like it was too much.",
    emojiImageKey: "overwhelmed",
  },
  {
    key: "could_not_concentrate",
    label: "Couldn’t concentrate",
    description: "Felt distracted.",
    emojiImageKey: "could_not_concentrate",
  },
];

function StudentMoodItem({
  studentMood,
  studentMoodComment,
  imageKey,
  active,
  nonClickable
}: {
  studentMood: string;
  imageKey: string;
  studentMoodComment?: string | null;
  active?: boolean;
  nonClickable?: boolean;
}) {
  const getStudentMoodImage = () => {
    switch (imageKey) {
      case "confident":
        return require("@/assets/images/confident.png");
      case "happy":
        return require("@/assets/images/happy.png");
      case "okay":
        return require("@/assets/images/okay.png");
      case "neutral":
        return require("@/assets/images/neutral.png");
      case "confused":
        return require("@/assets/images/confused.png");
      case "sad":
        return require("@/assets/images/sad.png");
      case "frustrated":
        return require("@/assets/images/frustrated.png");
      case "tired":
        return require("@/assets/images/tired.png");
      case "overwhelmed":
        return require("@/assets/images/overwhelmed.png");
      case "could_not_concentrate":
        return require("@/assets/images/could_not_concentrate.png");
      default:
        return null; // or a default image
    }
  };

  return (
    <View
      className={`gap-4 py-3 px-4 flex-row items-center ${nonClickable ? 'bg-teachLoop-creamDark' : 'bg-teachLoop-creamBase'} rounded-[9px] ${active ? "border-2 border-teachLoop-textPrimary" : ""}`}
    >
      <Image source={getStudentMoodImage()} style={{ width: 29, height: 29 }} />
      <View className="gap-1">
        <Text className="text-base font-geologica-medium font-medium text-black leading-[1.5]">
          {studentMood}
        </Text>
        <Text className="text-md font-geologica-regular font-normal text-black leading-[1.5]">
          {studentMoodComment}
        </Text>
      </View>
    </View>
  );
}

export default StudentMoodItem;
